function getPermissions (roles, userRoles, workspaces, currentWorkspace) {
  if (!userRoles || !roles || !currentWorkspace) {
    return false;
  }

  if (workspaces) {
    if (!(_.intersection(roles, userRoles).length > 0 || userRoles.includes('*') || roles.includes('*'))) {
      return false;
    }

    if (!(roles.includes('*') || workspaces.code !== currentWorkspace.code)) {
      return false;
    }

    return true;
  }

  return false;
}

function findRestrictions (restrictions, restrictionType, currentWorkspace, currentProject) {
  let restrictiosFound = [];

  if (restrictions && restrictions.length) {
    restrictiosFound = restrictions.filter(r => r.type === restrictionType && (r.workspaces.includes(currentWorkspace) || r.workspaces.includes('*')) && r.project === currentProject.toLowerCase());
  }

  return restrictiosFound;
}

function allowedContentTypes (contentTypesList, restrictions, currentWorkspaceCode, currentProject) {
  const allowContentsRestrictions = findRestrictions(restrictions, 'show_only_content_types', currentWorkspaceCode, currentProject);
  const forbiddenContentsRestrictions = findRestrictions(restrictions, 'restrict_content_types', currentWorkspaceCode, currentProject);

  allowContentsRestrictions.forEach(r => {
    if (r.settings.content_types.length > 0 && !r.settings.content_types.includes('*')) {
      contentTypesList = contentTypesList.filter(c => r.settings.content_types.includes(c.configs.wtype));
    }
  });

  forbiddenContentsRestrictions.forEach(r => {
    if (r.settings.content_types.includes('*')) {
      contentTypesList = [];
    } else {
      contentTypesList = contentTypesList.filter(c => !r.settings.content_types.includes(c.configs.wtype));
    }
  });

  return contentTypesList;
}

export { getPermissions, findRestrictions, allowedContentTypes };
